import HeroSlider from "../components/HeroSlider";
import TabsSection from "../components/TabsSection";
import NewProducts from "../components/NewProducts";
import Recommended from "../components/Recommended";
import InfoSection from "../components/InfoSection";
import FeatureSolutions from "../components/FeatureSolutions";
import NxCertified from "../components/NxCertified";
import CaseStudies from "../components/CaseStudies";
import GetMoreInfo from "../components/GetMoreInfo";

const Home = () => {
  return (
    <>
      {/* HERO SECTION */}
      <HeroSlider />

      <TabsSection />
      <NewProducts />
      <Recommended />
      <InfoSection />
      <FeatureSolutions />
      <NxCertified />
      <CaseStudies />
      <GetMoreInfo />
    </>
  );
};

export default Home;
